const Yatirim = resolve => {
    require.ensure(['../views/apps/yatirim/Yatirim'], () => {
        resolve(require('../views/apps/yatirim/Yatirim.vue'))
    })
};
const YatirimListesi = resolve => {
    require.ensure(['../views/apps/yatirim/YatirimListesi'], () => {
        resolve(require('../views/apps/yatirim/YatirimListesi.vue'))
    })
};
const YatirimTanimla = resolve => {
    require.ensure(['../views/apps/yatirim/YatirimTanimla'], () => {
        resolve(require('../views/apps/yatirim/YatirimTanimla.vue'))
    })
};

const YatirimGuncelle = resolve => {
    require.ensure(['../views/apps/yatirim/YatirimGuncelle'], () => {
        resolve(require('../views/apps/yatirim/YatirimGuncelle.vue'))
    })
};


import layouts from '../layout'
import Vue from 'vue'

Vue.component('yatirimlistesi', YatirimListesi);
Vue.component('yatirimtanimla', YatirimTanimla);
Vue.component('yatirimguncelle', YatirimGuncelle)

export default {
    path: '/yatirim',
    name: 'yatirim',
    component: Yatirim,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'liste',
            name: 'yatirimListesi',
            component: YatirimListesi,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },

    ],

}
